import { ThemeProvider } from "styled-components"
import { colors } from "../DEPRECATED/colors/index"
import { ToastProvider } from "../Toast"
import { bottom, left, right, top } from "../separator/separator.theme"
import { shadows } from "../shadows"
import { TypographyVariantsTheme } from "../typography"

export const theme = {
  colors,
  shadows,
  typography: TypographyVariantsTheme,
  separator: {
    top,
    bottom,
    left,
    right,
  },
  header: {
    defaultColors: "default",
  },
} as const

/** krypton styled-components provider */
export const KryptonProvider = ({ children, ...props }: { children: JSX.Element; [key: string]: unknown }) => (
  <ThemeProvider theme={theme} {...props}>
    {children}
    <ToastProvider />
  </ThemeProvider>
)
